import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQSection = ({ faqs }: any) => {
    if (!faqs || faqs.length === 0) return null;

    return (
        <div className="py-12 px-4 container mx-auto max-w-3xl">
            <h2 className="text-3xl font-bold text-center mb-8">الأسئلة الشائعة</h2>
            <Accordion type="single" collapsible>
                {faqs.map((faq: any, idx: number) => (
                    <AccordionItem key={idx} value={`item-${idx}`}>
                        <AccordionTrigger>{faq.question}</AccordionTrigger>
                        <AccordionContent>{faq.answer}</AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
};
